import { isStreamingLive } from '@core/livestream/helpers';
import { isAgora, isIVS, isVideo, } from '@core/video/videoElementWrapper/helpers';
import { useVideoEl } from '@embed/components/VideoPlayer/Player3/hooks/useVideoEl';
import { useStore } from '@embed/components/VideoPlayer/Player3/store';
/**
 * Determine whether show the subtitle control buttons
 * @returns Boolean
 */
export function useShowSubtitleControls() {
    const wrapper = useVideoEl();
    const video = useStore((state) => state.video);
    const liveStreamState = useStore((state) => state.liveStreamState);
    const videoSubtitleEnabled = isVideo(wrapper)
        ? !!video?.video_subtitles?.length
        : false;
    const ivsSubtitleEnabled = isIVS(wrapper)
        ? !!video?.live_stream_subtitles?.length
        : false;
    const agoraSubtitleEnabled = isAgora(wrapper)
        ? video?.live_stream_transcription_enabled &&
            isStreamingLive(liveStreamState)
        : false;
    return {
        showSubtitleControls: !!(videoSubtitleEnabled ||
            ivsSubtitleEnabled ||
            agoraSubtitleEnabled),
    };
}
